import { styled } from '@mui/material/styles'

export const ButtonWrapper = styled('div')`
  position: fixed;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #9b9a9a;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 12px;
  bottom: 80px;
  font-size: 16px;
  z-index: 1;
  cursor: pointer;
`
